/** Shared inline error banner used by module pages. */
export function ErrorAlert({ message }: { message: string }) {
  return (
    <div className="mb-6 rounded-md border border-brand-100 bg-brand-50 px-4 py-3 text-sm text-brand-700">
      {message}
    </div>
  );
}
